import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import XBigIcon from 'assets/svg/x_big.component.svg';

import { Mobile } from 'app/components/Responsive';

import './snackbar.scss';


export default function SnackBar(props) {
    const {
        shadowed = false,
        angular = false,
        symmetrical = false,
        onClickClose = () => {},
        children,
    } = props;

    const containerClasses = classNames({
        snackbar: true,
        shadowed,
        angular,
        symmetrical,
    });

    return (
        <div styleName={containerClasses}>
            <div styleName="snackbar__content">
                {children}
            </div>
            <div>
                {onClickClose ? (
                    <button
                        onClick={onClickClose}
                        styleName="snackbar__close"
                        type="button"
                        aria-label="Закрыть"
                        data-testid="snackbar-close"
                    >
                        <XBigIcon />
                    </button>
                ) : (
                    <Mobile>
                        <div styleName="snackbar__close" />
                    </Mobile>
                )}
            </div>
        </div>
    );
}

SnackBar.propTypes = {
    children: PropTypes.node.isRequired,
    shadowed: PropTypes.bool,
    angular: PropTypes.bool,
    symmetrical: PropTypes.bool,
    onClickClose: PropTypes.func,
};
